import config from "../config";

/**
 * Centralized Fetch wrapper that intercepts requests to automatically inject the Bearer token,
 * and intercepts 401 Unauthorized responses to trigger a logout.
 */
export const createApiClient = (token, logout) => {
  const fetchClient = async (endpoint, options = {}) => {
    const url = endpoint.startsWith("http") ? endpoint : `${config.API_BASE_URL}${endpoint}`;
    
    const headers = new Headers(options.headers || {});
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    
    const fetchOptions = {
      ...options,
      headers
    };

    try {
      const response = await fetch(url, fetchOptions);

      if (response.status === 401) {
        // Unauthorized - trigger logout and redirect
        logout();
        window.location.href = "/login?reason=expired";
        throw new Error("Session expired. Please log in again.");
      }
      
      return response;
    } catch (error) {
      throw error;
    }
  };

  return fetchClient;
};
